import { BlockingStatus } from '../enums/blockingStatusEnum';

export class UpdateStatus {
    finmaRegulation: boolean = false;
    comment: string;
    status: BlockingStatus
  }